import type { RefObject } from 'react';
import { Tabs, Box, Stack } from '@chakra-ui/react';
import PolygonOpacity from '@/components/toolbox/polygon-opacity';
import { ThemeSelection } from '@/components/toolbox/theme-selection';
import { BasemapSelection } from '@/components/toolbox/basemap-selection';
import { LayerSelection } from '@/components/toolbox/layer-selection';
import { ZoomSelection } from '@/components/toolbox/zoom-selection';
import Query from '@/components/toolbox/query';
import Search from '@/components/toolbox/search';

export default function Sidebar({ onClose, portalRef }: {
  onClose: () => void,
  // When rendered inside the mobile tools drawer, dropdowns must portal into
  // the drawer content instead of document.body (see tools-drawer.tsx).
  portalRef?: RefObject<HTMLDivElement | null>,
}) {
  return (
    <Box
      minW={{ base: 'full', lg: '20rem' }}
      maxW={{ base: 'full', lg: '20rem' }}
      position='sticky'
      top='0'
      left='0'
      overflowY='auto'
      overscrollBehavior='contain'
      minH='calc(100vh - 84px)'
      paddingInlineEnd='3'
      paddingInlineStart='3'
      borderRight='1px solid'
      borderColor='bg.muted'
      className='no-bg-scrollbar'
      transition='width 0.3s ease-in-out'
    >
      <Box paddingTop='4'  paddingBottom='6'>
        <Tabs.Root defaultValue='tools' variant='outline'>
          <Tabs.List>
            <Tabs.Trigger value='tools'>Tools</Tabs.Trigger>
            <Tabs.Trigger value='query'>Query</Tabs.Trigger>
            <Tabs.Trigger value='search'>Search</Tabs.Trigger>
          </Tabs.List>
          <Tabs.Content value='tools'>
            <Stack gap='4' paddingBottom='6' px='2'>
              <PolygonOpacity />
              <ThemeSelection portalRef={portalRef} />
              <BasemapSelection portalRef={portalRef} />
              <ZoomSelection portalRef={portalRef} />
              <LayerSelection />
            </Stack>
          </Tabs.Content>
          <Tabs.Content value='query'>
            <Query />
          </Tabs.Content>
          <Tabs.Content value='search'>
            <Search onClose={onClose} />
          </Tabs.Content>
        </Tabs.Root>
      </Box>
    </Box>
  );
}
